export const getAgentList = state => state.livemonitorReducer.agentList;
export const getFilter = state => state.livemonitorReducer.filter;
export const getStateList = state => state.livemonitorReducer.stateList;
export const getQueue = state => state.livemonitorReducer.queue;
export const getLiveChatData = state => state.livemonitorReducer.liveChatData;

export const getLiveDynamic = (state, options) => {
  return options.key ? state.livemonitorReducer[options.key] || "" : ""
};
export const getSingleAgentList = (state, options) => { return options.key ? state.livemonitorReducer.agentList[options.key] || "" : "" };
export const getSingleFilter = (state, options) => { return options.key ? state.livemonitorReducer.filter[options.key] || "" : "" };
export const getSingleStateList = (state, options) => { return options.key ? state.livemonitorReducer.stateList[options.key] || "" : "" };
export const getSingleQueue = (state, options) => { return options.key ? state.livemonitorReducer.queue[options.key] || "" : "" };
export const getLiveTranscriptionSet = (state) => {
  const liveTranscription = state.livemonitorReducer.liveTranscription;
  return liveTranscription;
};
export const getChatSummary = (state) => {
  const chatSummary = state.livemonitorReducer.chatSummary;
  return chatSummary;
}
export const getLiveTranscriptionUpdate = (state) =>
  state.livemonitorReducer.liveTranscriptionUpdate;

export const getChatSummaryLoading = (state) =>
  state.livemonitorReducer.chatSummaryLoading;


// WEBPACK FOOTER //
// src/store/selector/livemonitor.selector.js